export default __webpack_public_path__ + "static/media/Pc6.2cbbd824.jpg";